import { isCaregiver } from "../utils/userUtil";

export const useProfileProgress = (user) => {
  const progress = {
    complete: 0,
    total: 0,
    missing: [],
    hasBase: true,
  };

  if (!user) return progress;

  // This object tracks the required user properties
  const userProperties = {
    FirstName: {
      provided: user?.FirstName ? true : false,
      base: true,
      description: "First name",
    },
    LastName: {
      provided: user?.LastName ? true : false,
      base: true,
      description: "Last name",
    },
    Phone: {
      provided: user?.Phone ? true : false,
      description: "Phone number",
    },
    PhoneVerified: {
      provided: user?.PhoneVerified ? true : false,
      description: "Verify your phone number",
    },
    Avatar: {
      provided: user?.Avatar ? true : false,
      base: true,
      description: "Upload a profile photo",
    },
    Timezone: {
      provided: user?.Timezone ? true : false,
      description: "Select your timezone",
    },
  };

  // If user is a caregiver, add in Caregiver properties
  if (isCaregiver(user)) {
    userProperties.Availability = {
      provided: user?.Availability?.length > 0 ? true : false,
      description: "Set your availability",
    };
    userProperties.Rate = {
      provided: user?.Rate ? true : false,
      description: "Set your hourly rate",
    };
    // Categories, age range,bio
    userProperties.Categories = {
      provided: user?.Categories?.length > 0 ? true : false,
      description: "Set your categories",
    };
    userProperties.AgeRange = {
      provided: user?.AgeGroups?.length > 0 ? true : false,
      description: "Set your age groups",
    };
    userProperties.Bio = {
      provided: user?.Bio ? true : false,
      description: "Write a bio",
    };
  }

  for (const prop in userProperties) {
    progress.total++;
    if (userProperties[prop].provided === true) progress.complete++;
    else {
      progress.missing.push(userProperties[prop].description);
      if (userProperties[prop].base) progress.hasBase = false;
    }
  }

  // progress.hasBase =
  //   userProperties.filter((x) => x.base && !x.provided).length === 0;

  let percentage = Math.round((progress.complete / progress.total) * 100);
  progress.percentage = Math.floor(percentage / 5) * 5;

  return progress;
};
